import { createI18n } from 'vue-i18n'
import ptBR from '../locales/pt-BR.json'

type MessageSchema = typeof ptBR

export const i18n = createI18n<[MessageSchema], 'pt-BR'>({
  locale: 'pt-BR',
  legacy: false,
  messages: {
    'pt-BR': ptBR,
  },
  numberFormats: {
    'pt-BR': {
      currency: {
        style: 'currency',
        currency: 'BRL',
        notation: 'standard',
      },
    },
  },
  datetimeFormats: {
    'pt-BR': {
      short: {
        day: 'numeric',
        month: 'long',
      },
      only_numbers: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      only_month: {
        month: 'long',
      },
    },
  },
})
